import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Quagga from 'quagga'; // ES6
import { Lector } from 'src/app/_models';
import Swal from 'sweetalert2';
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});
@Component({
  selector: 'app-code-bar-scanner',
  templateUrl: './code-bar-scanner.component.html',
  styleUrls: ['./code-bar-scanner.component.css'],
})
export class CodeBarScannerComponent implements OnInit, AfterViewInit {
  constructor(
    public dialogRef: MatDialogRef<CodeBarScannerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Lector
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngAfterViewInit() {
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then(function (stream) {
        Quagga.init(
          {
            inputStream: {
              constraints: {
                width: 1920,
                height: 1080,
              },
              name: 'Live',
              type: 'LiveStream',
              target: document.querySelector('#codigoRead'), // Pasar el elemento del DOM
            },
            decoder: {
              readers: ['code_39_reader'],
            },
          },
          function (err) {
            if (err) {
              alert(err);

              return;
            }
            console.log('Iniciado correctamente');
            Quagga.start();
          }
        );

        Quagga.onProcessed(function (result) {
          var drawingCtx = Quagga.canvas.ctx.overlay,
            drawingCanvas = Quagga.canvas.dom.overlay;

          if (result) {
            if (result.boxes) {
              drawingCtx.clearRect(
                0,
                0,
                parseInt(drawingCanvas.getAttribute('width')),
                parseInt(drawingCanvas.getAttribute('height'))
              );
              result.boxes
                .filter(function (box) {
                  return box !== result.box;
                })
                .forEach(function (box) {
                  Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                    color: 'green',
                    lineWidth: 2,
                  });
                });
            }

            if (result.box) {
              Quagga.ImageDebug.drawPath(
                result.box,
                { x: 0, y: 1 },
                drawingCtx,
                {
                  color: '#00F',
                  lineWidth: 2,
                }
              );
            }

            if (result.codeResult && result.codeResult.code) {
              Quagga.ImageDebug.drawPath(
                result.line,
                { x: 'x', y: 'y' },
                drawingCtx,
                { color: 'red', lineWidth: 3 }
              );
            }
          }
        });
        Quagga.onDetected((data) => {
          alert(data.codeResult.code);
          // Imprimimos todo el data para que puedas depurar
          var botton = document.getElementById('datolector');
          botton.click();
        });
      })
      .catch(function (err) {
        Toast.fire({
          icon: 'info',
          title:
            'Your device does not have the resources and / or the necessary permissions for the activation of the video camera this resource is necessary for the use of a barcode reader',
          timer: 5000,
        });
        var botton = document.getElementById('cancelar');
        botton.click();
      });
  }

  ngOnInit(): void {}
}
